module.exports = __webpack_public_path__ + "static/img/aleksandra-svonja.6b427395.jpg";